import React, { useState, useEffect } from 'react';
import { generateInputField } from '../factory';
import ECreateToolbar from './ECreateToolbar';
import { useMediaQuery, Grid, Box, Typography } from '@mui/material';
import {
  AccordionForm,
  AccordionFormPanel,
  AccordionSection,
} from '@react-admin/ra-form-layout';
import { useRecordContext, useResourceContext } from 'react-admin';
import queryString from 'query-string';
import { useTranslate } from 'react-admin';



// Create a common rendering function to handle shared logic
const renderFields = (props, filteredFields, translate, resource) => {
  return (
    <Grid container item columnSpacing={2}>
      {filteredFields.map((f, innerIndex) => (
        <React.Fragment key={innerIndex}>
          {f.is_require_separator && <Box width="100%" />}
          {f.is_require_label && (
            <>
              <Typography variant="h6" gutterBottom>
                {translate(`resources.${resource}.fields.label_text`)}
              </Typography>
              <Box width="100%" />
            </>
          )}
          <Grid
            {...props}
            item
            size={{ xs: f.grid_xs || 4, sm: f.grid_sm || 4 }}
          >
            {generateInputField(f, innerIndex, props.id)}
          </Grid>
        </React.Fragment>
      ))}
    </Grid>
  );
};

const Form = (props) => {
  const [isDefaultValue, setIsDefaultValue] = useState(false);
  const [redirect, setRedirect] = useState('list');
  const [keyValue, setKeyValue] = useState(null);
  const [keyName, setKeyName] = useState(null);
  const [backTo, setBackTo] = useState(null);
  const [defaultFilterValue, setDefaultFilterValue] = useState(null);
  const [tab, setTab] = useState('');

  useEffect(() => {
    const { addShortCut: addShortCutString, keyValue: keyValueString, keyName: keyNameString, backTo: backToString, tab: tabString } = queryString.parse(window.location.hash);

    if (addShortCutString === 'true') {
      setIsDefaultValue(true);
      setKeyValue(keyValueString || '');
      setKeyName(keyNameString || '');
      setBackTo(backToString || '');
      setTab(tabString || '');

      if (keyValue && backTo) {
        setRedirect(`/${backTo}/${keyValue}/${tab}`);
        setDefaultFilterValue({ [keyName]: keyValue });
      }
    }
  }, []);

  const translate = useTranslate();
  const resource = useResourceContext();

  return (
    <AccordionForm
      {...props}
      autoClose
      defaultValue={isDefaultValue ? defaultFilterValue : {}}
      toolbar={<ECreateToolbar  />}
      redirect={redirect}
    >
      {props.tabs.map((t, index) => {
        if (t === 'root') {
          return renderFields(props, props.filteredFields[index], translate, resource);
        }
        return (
          <AccordionSection fullWidth defaultExpanded={true} label={t} key={index}>
            {renderFields(props, props.filteredFields[index], translate, resource)}
          </AccordionSection>
        );
      })}
    </AccordionForm>
  );
};

const UiAccordionForm = ({ canDelete,resourcesTabs, ...props }) => {
  const record = useRecordContext();
  const resourcesFields = props.resourcesFields;
  const filteredFields = resourcesFields.map((modelFields) =>
    modelFields && modelFields.filter((f) => {
      if (f.workflow_info && f.workflow_info.workflow_conditional == true) {
        const workflowColumn = f.workflow_info.workflow_column;
        const workflowConditionalShow = f.workflow_info.workflow_conditional_show.split(',').map(Number);
        const workflowConditionalReadonly = f.workflow_info.workflow_conditional_readonly.split(',').map(Number);

        if (record[workflowColumn] && workflowConditionalShow.includes(record[workflowColumn])) {
          if (record[workflowColumn] && workflowConditionalReadonly.includes(record[workflowColumn])) {
            f.input_widget_type = f.workflow_info.workflow_conditional_readonly_type;
          }
          return true;
        }
        return false;
      }
      return true;
    })
  );

  return <Form filteredFields={filteredFields} toolbar={props.toolbar} {...props} />;
};

export default UiAccordionForm;
